import {IStore} from '../../../shared/shared-models/store/store';
import {NavigationPageEnum} from '../models/navigations.enums';

/**
 * Store to select after login settings load, or null when the current selection must stay.
 * Replaces the alphabetical login default with the first store in display order.
 * A store the user already chose (anything other than that alphabetical default) is left unchanged.
 */
export function resolveDisplayOrderDefaultStore(
  selectedStore: IStore | undefined,
  displayOrderFirst: IStore | undefined,
  alphabeticalFirst: IStore | undefined,
): IStore | null {
  if (!displayOrderFirst?.storeId) {
    return null;
  }
  if (displayOrderFirst.storeId === selectedStore?.storeId) {
    return null;
  }
  if (
    selectedStore?.storeId
    && alphabeticalFirst?.storeId
    && selectedStore.storeId !== alphabeticalFirst.storeId
  ) {
    return null;
  }
  return displayOrderFirst;
}

/**
 * True while an automatic store change must wait.
 * Stock Take keeps the current store until the user leaves the module (FE-248).
 */
export function isAutomaticStoreChangeLocked(currentPage: string | null | undefined): boolean {
  return currentPage === NavigationPageEnum.StockTake;
}
